import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

import React, { useEffect } from "react"
import Lenis from "@studio-freight/lenis"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger)
}

// ★ props に location を受け取る
const WrapWithLenis = ({ element, props }) => {
  const pathname = props?.location?.pathname // 現在のページパスを取得

  useEffect(() => {
    if (typeof window !== "undefined") {
      const lenis = new Lenis({
        duration: 1.2,
        lerp: 0.08,
        smoothWheel: true,
      })

      // GSAP ScrollTrigger 同期設定
      lenis.on('scroll', ScrollTrigger.update)

      ScrollTrigger.scrollerProxy(document.body, {
        scrollTop(value) {
          return arguments.length ? lenis.scrollTo(value, { immediate: true }) : lenis.scroll;
        },
        getBoundingClientRect() {
          return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
        },
        pinType: document.body.style.transform ? "transform" : "fixed"
      })

      ScrollTrigger.addEventListener('refresh', () => lenis.resize())
      ScrollTrigger.refresh()

      // ▼ 【追加】ページ遷移時（かつハッシュが無い時）に Lenis でスクロールを一番上に即時リセット
      const hash = props?.location?.hash
      if (!hash) {
        lenis.scrollTo(0, { immediate: true })
      }

      // ★ ページ内リンク（#〜）のクリックを検出してLenisでスクロールさせる処理
      const handleAnchorClick = (e) => {
        const anchor = e.target.closest('a[href^="#"]')
        if (!anchor) return

        const href = anchor.getAttribute('href')
        if (!href || href === '#') return

        const targetEl = document.querySelector(href)
        if (targetEl) {
          e.preventDefault()
          lenis.scrollTo(targetEl, {
            offset: -120, // ★ 固定ヘッダーの高さ分だけ上を開ける設定
            duration: 1.4, // 移動にかかる時間
          })
        }
      }

      document.addEventListener('click', handleAnchorClick)

      // RAF（アニメーションフレーム）
      let rafId;
      function raf(time) {
        lenis.raf(time)
        rafId = requestAnimationFrame(raf)
      }
      rafId = requestAnimationFrame(raf)

      // クリーンアップ処理
      return () => {
        cancelAnimationFrame(rafId)
        document.removeEventListener('click', handleAnchorClick)
        lenis.destroy()
        ScrollTrigger.removeEventListener('refresh', () => lenis.resize())
      }
    }
  }, [pathname]) // ★ [pathname] を依存配列に入れることで、ページが変わるたびにLenisを再初期化＆位置リセットする

  return <>{element}</>
}

// ★ props を受け取って WrapWithLenis に渡す
export const wrapPageElement = ({ element, props }) => {
  return <WrapWithLenis element={element} props={props} />
}